import './picker.scss';
import { attachPropertiesToComponent } from './attach-properties-to-component';
import { CnPicker as Picker } from './picker';
import { prompt } from './prompt';
const CnPicker = attachPropertiesToComponent(Picker, {
    prompt,
});
export { CnPicker };
